/**
 * Live character counter for any snippets/input.liquid field rendered with
 * counter: true. DOM contract: the field carries `[data-field-counter]`;
 * its wrapping `.field` contains a `[data-field-counter-current]` span.
 */
document.addEventListener('input', (event) => {
  const field = event.target.closest('[data-field-counter]');
  if (!field) return;

  const display = field.closest('.field')?.querySelector('[data-field-counter-current]');
  if (display) display.textContent = field.value.length;
});
